import { render, staticRenderFns } from "./TrainingTrainingsForm.vue?vue&type=template&id=0f156242&"
import script from "./TrainingTrainingsForm.vue?vue&type=script&lang=js&"
export * from "./TrainingTrainingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports